import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, updateDoc, setDoc, getDoc } from 'firebase/firestore';
import { fs } from '../firebase';
import '../css/crmCard.css'

const AddCardCrm = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchRequests = async () => {
        setLoading(true);
        const querySnapshot = await getDocs(collection(fs, "cardRequests"));
        const list = [];
        querySnapshot.forEach((docSnap) => {
            list.push({ id: docSnap.id, ...docSnap.data() });
        });
        setRequests(list);
        setLoading(false);
    };

    useEffect(() => {
        fetchRequests();
    }, []);

    const handleApprove = async (request) => {
        try {
            const { cardNumber, cardType, uid, email, name, phone } = request;

            const cardRef = doc(fs, cardType, cardNumber);
            const cardSnap = await getDoc(cardRef);

            if (!cardSnap.exists()) {
                alert("Карта не найдена.");
                return;
            }

            const cardData = cardSnap.data();
            if (cardData.uid) {
                alert("Карта уже привязана к другому аккаунту.");
                return;
            }

            await updateDoc(cardRef, {
                uid,
                mail: email,
                name,
                phone
            });

            const userRef = doc(fs, "users", uid);
            await updateDoc(userRef, {
                cardNumber: cardNumber
            });

            const coinsRef = doc(fs, "coins", cardNumber);
            const coinsSnap = await getDoc(coinsRef);
            if (!coinsSnap.exists()) {
                await setDoc(coinsRef, {
                    nadimi: 0,
                    copacabana: 0,
                    aromiitaliani: 0,
                    poshnosh: 0,
                    symposium: 0
                });
            }

            const requestRef = doc(fs, "cardRequests", cardNumber);
            await updateDoc(requestRef, {
                status: "approved"
            });

            alert("Заявка одобрена и карта привязана.");
            fetchRequests();
        } catch (error) {
            console.error("Ошибка при одобрении:", error);
            alert("Ошибка при одобрении заявки.");
        }
    };

    const handleDecline = async (requestId) => {
        try {
            const requestRef = doc(fs, "cardRequests", requestId);
            await updateDoc(requestRef, {
                status: "declined"
            });

            alert("Заявка отклонена.");
            fetchRequests();
        } catch (error) {
            console.error("Ошибка при отклонении:", error);
            alert("Ошибка при отклонении заявки.");
        }
    };

    return (<div className={"crm-table-container"}>
            <div className="crm-container">
                <h2 className="crm-title">Управление картами временно отключено</h2>
                <div style={{
                    padding: '40px',
                    textAlign: 'center',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '8px',
                    margin: '20px 0'
                }}>
                    <p style={{ fontSize: '18px', color: '#666', marginBottom: '10px' }}>
                        🔒 Функция добавления и редактирования карт временно отключена
                    </p>
                    <p style={{ fontSize: '14px', color: '#888' }}>
                        Карты теперь управляются автоматически через систему
                    </p>
                </div>
            </div>
        </div>

    );
};

export default AddCardCrm;
